/* global document, window */
const filter = document.querySelector('#event-filter');
function filterEvents() {
  // The rebuilt full calendar owns its rows, count and filter state.
  if (document.querySelector('[data-full-events-page]')) return;
  let count = 0;
  for (const card of document.querySelectorAll('.calendar-card')) {
    card.hidden =
      new Date(card.dataset.ends) <= new Date() ||
      (filter && filter.value !== 'All events' && filter.value !== card.dataset.category);
    if (!card.hidden && !card.closest('[hidden]')) count++;
  }
  const label = document.querySelector('#event-count');
  if (label)
    label.textContent = count
      ? `${count} upcoming event${count === 1 ? '' : 's'}`
      : 'No upcoming events in this category. Try another category or check back soon.';
}
filter?.addEventListener('change', filterEvents);
document.addEventListener('somm:calendar-updated', filterEvents);
filterEvents();

// Mobile guide cards advance without changing their native swipe behavior.
const guideCarousel = document.querySelector('.team-carousel');
if (guideCarousel) {
  const mobileGuides = window.matchMedia('(max-width: 800px)');
  const reducedGuides = window.matchMedia('(prefers-reduced-motion: reduce)');
  const guideSlides = [...guideCarousel.querySelectorAll('.team-slide')];
  let guideTimer;
  let guideInteracted = false;
  let guideVisible = false;
  function stopGuides() {
    window.clearInterval(guideTimer);
    guideTimer = undefined;
  }
  function syncGuides() {
    stopGuides();
    if (
      !mobileGuides.matches ||
      reducedGuides.matches ||
      document.hidden ||
      !guideVisible ||
      guideInteracted
    )
      return;
    guideTimer = window.setInterval(() => {
      const left = guideCarousel.getBoundingClientRect().left;
      const inset = parseFloat(window.getComputedStyle(guideCarousel).paddingLeft) || 0;
      const current = guideSlides.reduce(
        (best, slide, i) =>
          Math.abs(slide.getBoundingClientRect().left - left - inset) <
          Math.abs(guideSlides[best].getBoundingClientRect().left - left - inset)
            ? i
            : best,
        0
      );
      const next = guideSlides[(current + 1) % guideSlides.length];
      guideCarousel.scrollTo({
        left: guideCarousel.scrollLeft + next.getBoundingClientRect().left - left - inset,
        behavior: 'smooth',
      });
    }, 7000);
  }
  function pauseGuides() {
    guideInteracted = true;
    stopGuides();
  }
  guideCarousel.addEventListener('pointerdown', pauseGuides, { passive: true });
  guideCarousel.addEventListener('touchstart', pauseGuides, { passive: true });
  guideCarousel.addEventListener('wheel', pauseGuides, { passive: true });
  guideCarousel.addEventListener('focusin', pauseGuides);
  mobileGuides.addEventListener('change', syncGuides);
  reducedGuides.addEventListener('change', syncGuides);
  document.addEventListener('visibilitychange', syncGuides);
  new window.IntersectionObserver(
    ([entry]) => {
      guideVisible = entry.isIntersecting;
      syncGuides();
    },
    { threshold: 0.2 }
  ).observe(guideCarousel);
}
